import React, { useContext } from "react";
import styled, { ThemeContext } from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faLinkedinIn,
  faTwitter,
} from "@fortawesome/free-brands-svg-icons";
import { faCircle } from "@fortawesome/free-solid-svg-icons";
import { Link } from "../Link";
import { Span } from "../Span";

interface Props {
  social: "facebook" | "linkedin" | "twitter";
}

const socialMappings = {
  facebook: {
    faIcon: faFacebookF,
    link: "https://www.facebook.com/vectornz/",
  },
  linkedin: {
    faIcon: faLinkedinIn,
    link: "https://www.linkedin.com/company/vector-limited/",
  },
  twitter: {
    faIcon: faTwitter,
    link: "https://twitter.com/vectorltd",
  },
};

const FAWrapper = styled(props => <Span {...props} />)``;

export const SocialIcon: React.FC<Props> = ({ social }) => {
  const theme = useContext(ThemeContext);
  const { faIcon, link } = socialMappings[social];
  const className = "fa-layers fa-2x";
  return (
    <Link
      href={link}
      aria-label={`Find us on ${social}`}
      mr={2}
      data-testid="sociallink"
    >
      <FAWrapper className={className} mb={2}>
        <FontAwesomeIcon icon={faCircle} color={theme.colors.accent} />
        <FontAwesomeIcon icon={faIcon} inverse transform="shrink-5" />
      </FAWrapper>
    </Link>
  );
};
